import { render, staticRenderFns } from "./lecCourseList.vue?vue&type=template&id=0c87744d&scoped=true"
import script from "./lecCourseList.vue?vue&type=script&lang=js"
export * from "./lecCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87744d",
  null
  
)

export default component.exports